const CarDriverComponent = () => import('@/views/WareHouse/CarDriver/CarDriverView')

export default [
    {
        path:'/CarDriverIndex',
        name:'CarDriverComponent',
        component:CarDriverComponent
    }
]